export enum IntegrationModes {
  STANDALONE = 'standalone',
  WCS = 'wcs',
}
